import { extendTheme, type ThemeConfig } from '@chakra-ui/react';

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

const theme = extendTheme({
  config,
  fonts: {
    heading: `'Carlito', 'Segoe UI', 'Inter', 'Roboto', sans-serif`,
    body: `'Carlito', 'Segoe UI', 'Inter', 'Roboto', sans-serif`,
  },
  colors: {
    brand: {
      50: '#e6f6ff',
      100: '#bae3ff',
      200: '#7cc4fa',
      300: '#47a3f3',
      400: '#2186eb',
      500: '#0967d2',
      600: '#0552b5',
      700: '#03449e',
      800: '#01337d',
      900: '#002159',
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'medium',
      },
    },
    Heading: {
      baseStyle: {
        fontWeight: 'semibold',
      },
    },
    Card: {
      baseStyle: {
        container: {
          boxShadow: 'md',
        }
      },
      variants: {
        elevated: (props: { colorMode: string }) => ({
          container: {
            bg: props.colorMode === 'dark' ? 'gray.800' : 'white',
          }
        })
      }
    },
    Stat: {
      variants: {
        outline: (props: { colorMode: string }) => ({
          container: {
            p: '5',
            bg: props.colorMode === 'dark' ? 'gray.800' : 'white',
            border: '1px solid',
            borderColor: props.colorMode === 'dark' ? 'gray.700' : 'gray.200',
            borderRadius: 'lg',
          }
        })
      }
    },
  },
  styles: {
    global: (props: { colorMode: string }) => ({
      body: {
        bg: props.colorMode === 'dark' ? 'gray.900' : 'gray.50',
        color: props.colorMode === 'dark' ? 'white' : 'gray.800',
      }
    })
  }
});

export default theme;